import RestRequest from "../tool/RestRequest";
import config from "../config";

export default class FavoriteService {

    static add(productId) {


        let params = new FormData();
        params.append('product_id', productId);

        return RestRequest.post(config.restFavorite, {
            body: params
        });
    }

    static remove(productId) {
        return RestRequest.delete(config.restFavorite, productId);
    }

    static updateCounter(minus = false) {
        const counterList = document.querySelectorAll('.js-favorite-counter');

        if (counterList) {

            counterList.forEach(counter => {
                let count = parseInt(counter.textContent ?? 0);

                if (minus) {
                    count--;
                } else {
                    count++;
                }

                counter.textContent = count;

                if (count > 0) {
                    counter.classList.add('is-active')
                } else {
                    counter.classList.remove('is-active')
                }
            });
        }
    }
}